import React, { Component } from 'react';
import b from 'b_';

import './banner.css';

interface BannerProps {
    title: string;
    description: string;
    image: string;
}

const class_ = b.with('banner');

class Banner extends Component<BannerProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { title, description, image } = this.props;

        return (
            <div className={class_()}>
                <img className={class_('image')} src={image} />

                <div className={class_('texts')}>
                    <h1 className={class_('title')}>{title}</h1>
                    <div className={class_('description')}>{description}</div>
                </div>
            </div>
        );
    }
}

export default Banner;
